import { CompanyState } from './company.types';

/**
 *  Holding the state of the footer.
 */
export const State: { company: CompanyState; } = {
    company: {
        details: null,
    },
};
